import { render, staticRenderFns } from "./productCategory.vue?vue&type=template&id=068aa264&scoped=true"
import script from "./productCategory.vue?vue&type=script&lang=js"
export * from "./productCategory.vue?vue&type=script&lang=js"
import style0 from "./productCategory.vue?vue&type=style&index=0&id=068aa264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068aa264",
  null
  
)

export default component.exports